import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/Styles/Theme.css";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Contact from "./Components/ContactUs/Contact";
import Login from "./Components/Profile/Login";
import "./App.css";
import { UserProfile } from "./Components/UserProfile/UserProfile";
import Profile from "./Components/UserProfile/Profile";
import {
  LocationProvider,
  useLocationContext,
} from "./Context/LocationContext";
import AddressModalContainer from "./Modal/AddressModalContainer";

function LocationPermissionPopup() {
  const { detectLocation } = useLocationContext();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const status = localStorage.getItem("location_permission_status");

    if (!status) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="location-cookie-popup">
      <div className="location-cookie-box">
        <h3>Allow Location Access?</h3>
        <p>We use your location to show nearby services.</p>

        <div className="location-cookie-actions">
          <button
            className="btn-allow"
            onClick={() => {
              detectLocation();
              localStorage.setItem("location_permission_status", "allowed");

              setShow(false);
            }}
          >
            Allow
          </button>

          <button
            className="btn-deny"
            onClick={() => {
              localStorage.setItem("location_permission_status", "denied");

              setShow(false);
            }}
          >
            Not Now
          </button>
        </div>
      </div>
    </div>
  );
}
function App() {
  return (
    <LocationProvider>
      <BrowserRouter>
        <LocationPermissionPopup />
        <AddressModalContainer />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/user-profile" element={<UserProfile />}>
            <Route path="/user-profile/profile" element={<Profile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LocationProvider>
  );
}

export default App;
